import { api } from './client'

export type StatsScope =
    'products' | 'packaging' | 'sorting' | 'scenting' | 'agri_materials' | 'all'

export type StatsGroupBy = 'day' | 'week' | 'month'

export interface InOutStatsParams {
    period: string
    days?: number
    from?: string
    to?: string
    scope?: StatsScope
    warehouse_id?: string
    group_by?: StatsGroupBy
    group_dim?: string
    ref_ids?: string
}

export type SnapshotKind =
    'product' | 'packaging' | 'sorting' | 'scenting' | 'agri_materials'
export type SnapshotStatus = 'pending' | 'approved'

export interface SnapshotBatchSummary {
    id: string
    snapshot_date: string
    kind: SnapshotKind
    status: SnapshotStatus
    source: string
    // True cho snapshot morning-auto (auto-tạo khi kiểm sáng T+1). Không hiện
    // trong list "Chốt sổ". Trả về khi query có include_internal=true.
    is_internal?: boolean
    approved_by_name?: string
    approved_at?: string
    total_lots: number
    total_quantity: number
    created_at: string
}

export interface InOutSummary {
    scope: string
    label: string
    total_in: number
    total_out: number
    net: number
    doc_count_in: number
    doc_count_out: number
    unit: string
}

export interface InOutSeriesPoint {
    scope: string
    bucket: string
    ref_id?: string
    in: number
    out: number
    /** Tồn cuối bucket (chỉ set cho series tổng khi scope hỗ trợ tồn). */
    balance?: number
}

export interface InOutBreakdownItem {
    scope: string
    ref_id: string
    code: string
    name: string
    in: number
    out: number
    /** Tồn cuối kỳ của đầu mục (chỉ set khi scope hỗ trợ tồn). */
    on_hand?: number
}

export interface InOutStatsResult {
    period: {
        preset: string
        from: string
        to: string
        group_by: string
    }
    summary: InOutSummary[]
    series: InOutSeriesPoint[]
    breakdown: InOutBreakdownItem[]
}

export const inventoryStatsApi = {
    inOut: (params: InOutStatsParams) =>
        api.get<InOutStatsResult>('/inventory/stats/in-out', { params }),

    // Excel bảng "Top biến động trong kỳ". Nhận đúng params của inOut nên file
    // tải về khớp chính xác bảng đang hiển thị.
    downloadInOutExcel: (params: InOutStatsParams) =>
        api.getBlob('/inventory/stats/in-out/excel', { params }),
}

export const snapshotBatchApi = {
    list: (params: {
        kind: SnapshotKind
        from?: string
        to?: string
        // Đặt true nếu cần thấy snapshot morning-auto (debug/admin). Mặc định
        // BE filter is_internal=FALSE cho luồng user thường.
        include_internal?: boolean
    }) =>
        api.get<SnapshotBatchSummary[]>('/inventory/snapshots/batches', {
            params,
        }),

    chotSo: (body: { kind: SnapshotKind; date?: string }) =>
        api.post<{ batch_id: string; status: string; total_lots: number }>(
            '/inventory/snapshots/chot-so',
            body,
        ),

    approve: (id: string) =>
        api.post<SnapshotBatchSummary>(
            `/inventory/snapshots/batches/${id}/approve`,
            {},
        ),

    downloadExcel: (id: string) =>
        api.getBlob(`/inventory/snapshots/batches/${id}/excel`),
}
